var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user
    ? _c("div", { staticClass: "admin-user-summary sip-view-summary" }, [
        _c("div", { staticClass: "sip-view-summary__hero" }, [
          _c("div", { staticClass: "sip-view-summary__avatar" }, [
            _c("img", { attrs: { src: _vm.getAvatar(_vm.user), alt: "" } }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sip-view-summary__info" }, [
            _c("h5", { staticClass: "sip-view-summary__name" }, [
              _vm._v(
                _vm._s(
                  _vm.user.profile.first_name + " " + _vm.user.profile.last_name
                )
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sip-view-summary__email" }, [
              _vm._v(_vm._s(_vm.user.email)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sip-view-summary__badges" },
              [
                _vm.user.profile.gender
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "admin-status-badge admin-status-badge--info",
                      },
                      [_vm._v(_vm._s(_vm.user.profile.gender))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.getUserStatus(_vm.user), function (status) {
                  return _c(
                    "span",
                    {
                      key: status.label,
                      class: [
                        "admin-status-badge",
                        "admin-status-badge--" + status.color,
                      ],
                    },
                    [_vm._v(_vm._s(status.label))]
                  )
                }),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.hasSocial
          ? _c("div", { staticClass: "sip-view-summary__social" }, [
              _c("ul", { staticClass: "sip-view-summary__social-list" }, [
                _vm.user.profile.facebook_profile
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.user.profile.facebook_profile,
                            "aria-label": "Facebook",
                          },
                        },
                        [_c("admin-icon", { attrs: { name: "globe" } })],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.user.profile.twitter_profile
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.user.profile.twitter_profile,
                            "aria-label": "Twitter",
                          },
                        },
                        [_c("admin-icon", { attrs: { name: "globe" } })],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.user.profile.linkedin_profile
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.user.profile.linkedin_profile,
                            "aria-label": "LinkedIn",
                          },
                        },
                        [_c("admin-icon", { attrs: { name: "globe" } })],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.user.profile.google_plus_profile
                  ? _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.user.profile.google_plus_profile,
                            "aria-label": "Google",
                          },
                        },
                        [_c("admin-icon", { attrs: { name: "globe" } })],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.user.id != _vm.getAuthUser("id")
          ? _c("div", { staticClass: "sip-view-summary__actions" }, [
              _vm.user.status == "activated"
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.updateStatus("banned")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-ban" }),
                      _vm._v(" " + _vm._s(_vm.trans("user.user_action_ban"))),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user.status == "disapproved"
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.updateStatus("activated")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(
                        " " + _vm._s(_vm.trans("user.user_action_approve"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user.status == "pending_activation" ||
              _vm.user.status == "pending_approval"
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.updateStatus("activated")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-user-plus" }),
                      _vm._v(
                        " " + _vm._s(_vm.trans("user.user_action_approve"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user.status == "pending_activation" ||
              _vm.user.status == "pending_approval"
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.updateStatus("disapproved")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-user-times" }),
                      _vm._v(
                        " " + _vm._s(_vm.trans("user.user_action_disapprove"))
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user.status == "banned"
                ? _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-block btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.updateStatus("activated")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-check" }),
                      _vm._v(
                        " " + _vm._s(_vm.trans("user.user_action_activate"))
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("dl", { staticClass: "sip-view-dl sip-view-summary__meta" }, [
          _c("div", { staticClass: "sip-view-dl__row" }, [
            _c("dt", [_vm._v(_vm._s(_vm.trans("user.date_of_birth")))]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(_vm._s(_vm._f("moment")(_vm.user.profile.date_of_birth))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sip-view-dl__row" }, [
            _c("dt", [_vm._v(_vm._s(_vm.trans("user.date_of_anniversary")))]),
            _vm._v(" "),
            _c("dd", [
              _vm._v(
                _vm._s(_vm._f("moment")(_vm.user.profile.date_of_anniversary))
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sip-view-dl__row" }, [
            _c("dt", [_vm._v(_vm._s(_vm.trans("user.created_at")))]),
            _vm._v(" "),
            _c("dd", [_vm._v(_vm._s(_vm._f("moment")(_vm.user.created_at)))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sip-view-dl__row" }, [
            _c("dt", [_vm._v(_vm._s(_vm.trans("user.phone")))]),
            _vm._v(" "),
            _c("dd", [_vm._v(_vm._s(_vm.user.profile.phone || "—"))]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }